import React from 'react';

const BARS = [14, 26, 40, 54, 54, 40, 26, 14];

/**
 * The banner: a voice becoming gourdes. Line art in the manner of FotoLekti's
 * hero; the bars move while the app is listening or speaking (see .hero-bar in
 * App.css), and flow into the gourde.
 */
export default function Hero() {
  return (
    <div className="hero" aria-hidden="true">
      <svg viewBox="0 0 320 104" fill="none" strokeLinecap="round">
        <defs>
          <linearGradient id="hero-flow" gradientUnits="userSpaceOnUse" x1="75" y1="0" x2="181" y2="0">
            <stop offset="0" className="hero-stop-warm" />
            <stop offset="1" className="hero-stop-ink" />
          </linearGradient>
        </defs>
        <g stroke="url(#hero-flow)">
          {BARS.map((h, i) => (
            <line key={i} className="hero-bar" style={{ '--i': i }} strokeWidth="3.2"
              x1={79 + i * 8} x2={79 + i * 8} y1={52 - h / 2} y2={52 + h / 2} />
          ))}
          <path d="M141 52 C149 52 151 68 161 68 S173 52 181 52" strokeWidth="2.4" />
        </g>
        <g className="hero-coin">
          <circle cx="211" cy="52" r="30" strokeWidth="2.2" />
          <circle cx="211" cy="52" r="23.5" strokeWidth="1.1" opacity="0.55" />
          <text x="211" y="63" textAnchor="middle">G</text>
        </g>
      </svg>
    </div>
  );
}
